/**
 * App.js
 * -----------------------------------------------------------------------------
 * Top-level layout + router. Public routes: /login, /signup. Everything else
 * is wrapped in <ProtectedRoute /> which redirects unauthenticated users to
 * /login.
 */

import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';

import Navbar          from './components/Navbar';
import Footer          from './components/Footer';
import ProtectedRoute  from './components/ProtectedRoute';

import Login     from './pages/Login';
import Signup    from './pages/Signup';
import Dashboard from './pages/Dashboard';
import Upload    from './pages/Upload';
import Settings  from './pages/Settings';
import Privacy   from './pages/Privacy';
import Terms     from './pages/Terms';
import Support   from './pages/Support';

export default function App() {
    return (
        <div className="min-h-full flex flex-col">
            <Navbar />
            <main className="flex-1 max-w-6xl w-full mx-auto px-4 py-6">
                <Routes>
                    {/* Public routes */}
                    <Route path="/login"   element={<Login />} />
                    <Route path="/signup"  element={<Signup />} />
                    <Route path="/privacy" element={<Privacy />} />
                    <Route path="/terms"   element={<Terms />} />
                    <Route path="/support" element={<Support />} />

                    {/* Protected routes */}
                    <Route path="/" element={
                        <ProtectedRoute><Dashboard /></ProtectedRoute>
                    } />
                    <Route path="/upload" element={
                        <ProtectedRoute><Upload /></ProtectedRoute>
                    } />
                    <Route path="/settings" element={
                        <ProtectedRoute><Settings /></ProtectedRoute>
                    } />

                    <Route path="*" element={<Navigate to="/" replace />} />
                </Routes>
            </main>
            <Footer />
        </div>
    );
}
